import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/buttons/buttons";
import Table from "../../../../components/tables/tableCols1";
import TableSkeleton from "../../../../components/skeleton/table";
import TableFilter from "../../../../components/tables/tableFilter";
import { Pagination } from "../../../../components/pagination/pagination";
import {
  filterBusinessAction,
  filterBusinessActionNoPage,
  searchBusinessAction,
} from "../../../../redux/business/businessActions";
import Business from "../../../../assets/images/icons/BusinessEmpty.svg";
import { writeFileWithXLSX } from "../../../../components/exports/xlsx";
import { AllFiltersModal } from "../../../../components/modals/allFiltersModal";
import FilterBusinessDropDown from "../../../../components/dropDown/filter/filterBusiness";

export default function RevenueBusinesses() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { allBusinesses, filtering, filterNoPage } = useSelector(
    (state) => state.business,
  );

  const [payLoad] = useState({
    // management_approved: 1,
    end_date: new Date(),
  });

  const [isFilterOpen, setFilterState] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });

  useEffect(() => {
    dispatch(filterBusinessAction(payLoad, params.page || 1));
    dispatch(filterBusinessActionNoPage(payLoad));
  }, [dispatch, payLoad, params]);

  function createTableData(data) {
    const dataToMap = data;
    console.log("data", data);
    if (Array.isArray(dataToMap)) {
      const outputArray = [];
      dataToMap.forEach((business, index) => {
        const single = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: business?.business_name,
          email: business?.business_email,
          location: business?.business_city,
          business: business,
        };

        outputArray.push({ single });
      });

      return outputArray;
    }
    return [];
  }

  useEffect(() => {
    const dataSet = createTableData(allBusinesses?.data);
    setData(dataSet);
  }, [allBusinesses]);

  function createTableNoPage(data) {
    const dataToMap = data;
    if (Array.isArray(dataToMap)) {
      const outputArray = [];
      dataToMap.forEach((business) => {
        const single = {
          name: business?.business_name,
          email: business?.business_email,
          location: business?.business_city,
        };

        outputArray.push(single);
      });

      return outputArray;
    }
    return [];
  }

  const goToSinglePage = (params) => {
    const id = params?.single?.business?.id;
    navigate(`/admin/revenue/business/${id}/payouts`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setIsSearchOpen(true);
      dispatch(searchBusinessAction({ search: input?.search }));
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "S/N",
            accessor: "single.num",
          },
          {
            Header: "Business Name",
            accessor: "single.name",
          },
          {
            Header: "Email",
            accessor: "single.email",
          },
          {
            Header: "Location",
            accessor: "single.location",
          },
        ],
      },
    ],
    [],
  );

  const dataForExport = useMemo(() => {
    return createTableNoPage(filterNoPage?.data);
  }, [filterNoPage]);

  const handleExport = () => {
    writeFileWithXLSX(dataForExport, "businesses-revenue");
  };

  return (
    <div>
      <TableFilter
        results={allBusinesses?.data?.length || 0}
        searchPlaceholder={"Search by business name, email or location"}
        title={`Showing ${allBusinesses?.data?.length || 0} of ${
          allBusinesses?.meta?.total || 0
        } results`}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterBusinessDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
      >
        <Button.Primary title={"Export"} onClick={handleExport} />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      {filtering ? (
        <TableSkeleton />
      ) : (
        <div className="bg-white dark:bg-[#121212] rounded-md py-4 px-3">
          {data?.length > 0 ? (
            <div>
              <Table
                columns={columns}
                data={data?.length > 0 ? data : []}
                onClick={goToSinglePage}
                goToSinglePage={goToSinglePage}
              />
            </div>
          ) : (
            <div className="bg-white dark:bg-[#121212] rounded-md py-12 px-8 text-center">
              <img
                src={Business}
                alt="empty"
                className="w-32 h-32 mx-auto mb-4"
              />
              <p className="text-gray-500 dark:text-gray-400">
                No businesses found
              </p>
            </div>
          )}

          {!isSearchOpen && (
            <Pagination
              data={allBusinesses}
              route={"admin/revenue/businesses"}
            />
          )}
        </div>
      )}
    </div>
  );
}
